import {
  COMPANY_MANAGER_FETCH_REQUEST,
  COMPANY_MANAGER_FETCH_SUCCESS,
  COMPANY_MANAGER_FETCH_FAILURE,
  COMPANY_MANAGER_SET_SEARCH,
  COMPANY_MANAGER_SET_SHOW_ARCHIVED,
  COMPANY_MANAGER_SET_FILTERS,
  COMPANY_MANAGER_CLEAR_FILTERS,
  COMPANY_MANAGER_SET_PAGE,
  COMPANY_MANAGER_SET_PAGE_SIZE,
  COMPANY_MANAGER_SET_INDUSTRY_OPTIONS,
  COMPANY_MANAGER_ADD_REQUEST,
  COMPANY_MANAGER_ADD_SUCCESS,
  COMPANY_MANAGER_ADD_FAILURE,
  COMPANY_MANAGER_FETCH_DROPDOWN_REQUEST,
  COMPANY_MANAGER_FETCH_DROPDOWN_SUCCESS,
  COMPANY_MANAGER_FETCH_DROPDOWN_FAILURE,
} from '../actions/actionTypes';
import { CompanyManagerAction, EMPTY_COMPANY_FILTERS } from '../actions/companyManagerActions';

export interface CompanyRow {
  id: string;
  name: string;
  linkedin: string | null;
  website: string | null;
  description: string | null;
  headquarters: string | null;
  specialties: string | null;
  industry: string | null;
  industry_name: string | null;
  country_id: string | null;
  country_details: { country_flag: string; country_name: string } | null;
  country_zone: string | null;
  employee_count: number | null;
  picture: string | null;
  metadata: Record<string, any> | null;
  created_at: string | null;
}

interface CompanyManagerState {
  companies: CompanyRow[];
  loading: boolean;
  error: string | null;
  search: string;
  showArchived: boolean;
  filters: typeof EMPTY_COMPANY_FILTERS;
  pagination: { page: number; pageSize: number; total: number; totalPages: number };
  industryOptions: { id: string; label: string }[];
  addLoading: boolean;
  addError: string | null;
  companiesForDropdown: CompanyRow[];
  companiesForDropdownLoading: boolean;
}

const initialState: CompanyManagerState = {
  companies: [],
  loading: false,
  error: null,
  search: '',
  showArchived: false,
  filters: EMPTY_COMPANY_FILTERS,
  pagination: { page: 1, pageSize: 20, total: 0, totalPages: 0 },
  industryOptions: [],
  addLoading: false,
  addError: null,
  companiesForDropdown: [],
  companiesForDropdownLoading: false,
};

export default function companyManagerReducer(
  state = initialState,
  action: CompanyManagerAction,
): CompanyManagerState {
  switch (action.type) {
    case COMPANY_MANAGER_FETCH_REQUEST:
      return { ...state, loading: true, error: null };
    case COMPANY_MANAGER_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        companies: action.payload.data,
        pagination: action.payload.pagination,
      };
    case COMPANY_MANAGER_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case COMPANY_MANAGER_SET_SEARCH:
      return { ...state, search: action.payload, pagination: { ...state.pagination, page: 1 } };
    case COMPANY_MANAGER_SET_SHOW_ARCHIVED:
      return { ...state, showArchived: action.payload, pagination: { ...state.pagination, page: 1 } };
    case COMPANY_MANAGER_SET_FILTERS:
      return { ...state, filters: action.payload, pagination: { ...state.pagination, page: 1 } };
    case COMPANY_MANAGER_CLEAR_FILTERS:
      return { ...state, filters: EMPTY_COMPANY_FILTERS, pagination: { ...state.pagination, page: 1 } };
    case COMPANY_MANAGER_SET_PAGE:
      return { ...state, pagination: { ...state.pagination, page: action.payload } };
    case COMPANY_MANAGER_SET_PAGE_SIZE:
      return { ...state, pagination: { ...state.pagination, pageSize: action.payload, page: 1 } };
    case COMPANY_MANAGER_SET_INDUSTRY_OPTIONS:
      return { ...state, industryOptions: action.payload };
    case COMPANY_MANAGER_ADD_REQUEST:
      return { ...state, addLoading: true, addError: null };
    case COMPANY_MANAGER_ADD_SUCCESS:
      return { ...state, addLoading: false, addError: null };
    case COMPANY_MANAGER_ADD_FAILURE:
      return { ...state, addLoading: false, addError: action.payload };
    case COMPANY_MANAGER_FETCH_DROPDOWN_REQUEST:
      return { ...state, companiesForDropdownLoading: true };
    case COMPANY_MANAGER_FETCH_DROPDOWN_SUCCESS:
      return { ...state, companiesForDropdownLoading: false, companiesForDropdown: action.payload };
    case COMPANY_MANAGER_FETCH_DROPDOWN_FAILURE:
      return { ...state, companiesForDropdownLoading: false };
    default:
      return state;
  }
}
